module.exports = __webpack_public_path__ + "media/images/sp/items/album/standard-ff5bb51b1f164778c9fadc28128e0b00.jpg";